import {initImmersiveOnboarding as initLegacyOnboarding} from 'common/onboarding/immersive-onboarding-legacy';
import {initImmersiveOnboarding as initDocsOnboarding} from 'common/onboarding/immersive-onboarding';
import {CurrentProjectResource} from 'common/report/model-resources/projects';
import {isAutocaptureInDocsEnabled} from 'common/report/util/feature-sampling';

interface ImmersiveOnboardingOptions {
  useDocsOnboarding?: boolean;
  currentProjectResource?: CurrentProjectResource;
}

export const initializeImmersiveOnboarding = (options?: ImmersiveOnboardingOptions) => {
  const useDocsOnboarding =
    options?.useDocsOnboarding ?? isAutocaptureInDocsEnabled(options?.currentProjectResource?.get().value);
  return useDocsOnboarding ? initDocsOnboarding() : initLegacyOnboarding();
};
